import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Link } from 'react-router-dom';
import queryString from 'query-string';
import { actions as authActions } from '../../../actions/budgetAuthActions';
import routePaths from '../../../routePaths';
import SignInForm from './SignInForm';
import AnonymousContentPanel from '../AnonymousContentPanel';
import './SignInPageStyles.scss';

class SignInPage extends React.Component {
  componentDidMount() {
    if (this.props.token) this.props.authActions.activateAccount({ activationToken: this.props.token });
  }

  render() {
    const { authActions, returnTo } = this.props;
    return (
      <div style={{ display: 'flex', justifyContent: 'center'}}>
        <AnonymousContentPanel style={{ maxWidth: 400, width: '100%' }}>
          <SignInForm onSubmit={data => authActions.signIn(data, returnTo)} />
          <div className="password-recovery-link">
            <div><Link to={routePaths.budgetAuth.registration}>Utwórz nowe konto</Link></div>
            <div><Link to={routePaths.budgetAuth.passwordRecovery}>Zapomniałem hasła</Link></div>
          </div>
        </AnonymousContentPanel>
      </div>
    );
  }
}

SignInPage.propTypes = {
  authActions: PropTypes.object.isRequired,
  returnTo: PropTypes.string,
  token: PropTypes.string,
};

function mapDispatchToProps(dispatch) {
  return {
    authActions: bindActionCreators(authActions, dispatch),
  };
}

function mapStateToProps(_, ownProps) {
  const parsed = queryString.parse(ownProps.location.search);
  
  return {
    returnTo: parsed.returnTo,
    token: parsed.token,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(SignInPage);



// WEBPACK FOOTER //
// ./src/components/budgetAuth/signIn/SignInPage.js